module.exports = __webpack_public_path__ + "img/about_us_bkg.daafdad5.png";